import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 8,
  width: "100%",
  marginBottom: 14,
}));

export const Title = styled("div")(() => ({
  fontSize: 13,
  color: "#555",
}));

export const CardRow = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 10,

  [theme.down("sm")]: {
    flexDirection: "column",
  },
}));

export const Card = styled("button")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  alignItems: "flex-start",
  gap: 4,
  flex: 1,
  minWidth: 0,
  padding: "10px 14px",
  backgroundColor: "#fff",
  border: "1px solid #ddd",
  borderRadius: 6,
  boxShadow: "0 1px 5px rgba(0, 0, 0, 0.15)",
  textAlign: "left",
  cursor: "pointer",
  transition: "border-color .2s ease, box-shadow .2s ease",

  "&:hover": {
    borderColor: theme.palette?.primary || "#E63946",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
  },
}));

export const CardLabel = styled("div")(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  textTransform: "uppercase",
  color: theme.palette?.primary || "#E63946",
}));

export const CardText = styled("div")(() => ({
  fontSize: 13,
  color: "#333",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
}));

export const CardPrice = styled("div")(() => ({
  fontSize: 16,
  fontWeight: 700,
  color: "#151515",
}));
